<!-- //
数据源选择器
@auth xuyd
@date 2024-05-04
//-->
<template>
  <SelectorRemote v-model="inputData"
                  :options="options"
                  popper-class="dv-select-pop"
                  :datasource-list="datasourceList"
                  placeholder="请选择数据源"
                  @change="handleChange"
                  :remote-method="handleRemoteMethod"/>
</template>

<script>
import ApiDs from '@/api/datasvc/apiDesign.api.js';

export default {
  name: 'SelectDataSource',
  data() {
    return {
      inputData: this.value,
      options: {size: 'mini', value: 'apiName', label: 'apiComment', req: 'reqParams', resp: 'respResult'},
      list: [],
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  props:{
    value: [String, Number],
    label: [String, Number],
  },
  computed: {
    datasourceList() {// 构造出下拉
      if(this.value && this.label) {
        let l = {};
        l[this.options.value] = this.value;
        l[this.options.label] = this.label;
        return [l]
      } else {
        return [];
      }
    }
  },
  watch: {
    value: {
      handler: function (val) {
        this.inputData = val;
      },
      immediate: true
    },
  },
  methods: {
    handleRemoteMethod(val) {
      if(!val) return;
      console.log("-------handleRemoteMethod-------",val, JSON.stringify(val))
      return ApiDs.queryApiDs(val);
    },
    handleChange(val, item) {
      this.$emit('change', val, {
                  value: item[this.options.value],
                  label: item[this.options.label],
                  req: item[this.options.req],
                  resp: item[this.options.resp]}
      );
    }
  }
}
</script>

<style lang="less" scoped>
</style>

